module.exports = __webpack_public_path__ + "img/gu.58be541e.svg";